import { render, staticRenderFns } from "./HeaderFichaPartido.vue?vue&type=template&id=77cfbbd0&scoped=true&"
import script from "./HeaderFichaPartido.vue?vue&type=script&lang=js&"
export * from "./HeaderFichaPartido.vue?vue&type=script&lang=js&"
import style0 from "./HeaderFichaPartido.vue?vue&type=style&index=0&id=77cfbbd0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77cfbbd0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
installComponents(component, {
  VIcon,
  VImg,
})
